const BrandColorExampleAvatar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 25 25"
  >
    <circle
      cx="12.785"
      cy="12.523"
      r="11.284"
      fill="currentColor"
      strokeWidth="1.244"
    />
    <g clipPath="url(#a-avatar)">
      <rect
        x="3.189"
        y="2.927"
        width="19.191"
        height="19.191"
        rx="9.595"
        fill="#EAEAEA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.987 9.058a3.798 3.798 0 1 1 7.596 0 3.798 3.798 0 0 1-7.596 0ZM5.823 20.963a6.964 6.964 0 0 1 13.925 0 .633.633 0 0 1-.37.587 15.772 15.772 0 0 1-6.593 1.435c-2.351 0-4.586-.513-6.594-1.435a.633.633 0 0 1-.368-.587Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a-avatar">
        <rect
          x="3.189"
          y="2.927"
          width="19.191"
          height="19.191"
          rx="9.595"
          fill="#fff"
        />
      </clipPath>
    </defs>
  </svg>
);

export default BrandColorExampleAvatar;
